<template>
  <!--Main Slider-->
  <!--Main Slider-->
  <section id="main-banner-area">
    <div class="slider">
      <div class="list">
        <!-- Dynamic slider items -->
      </div>
    </div>

    <div
      class="tp-bullets numbered vertical nav-pos-hor-left nav-pos-ver-center nav-dir-vertical white"
      style="
        height: 55px;
        width: 15.3167px;
        top: 50%;
        transform: matrix(1, 0, 0, 1, 20, -27);
        left: 0px;
      "
    >
      <!-- Dynamic pagination bullets -->
    </div>

    <ul class="social-icons-simple revicon white">
      <li class="d-table" v-for="(item, index) in listSocialMedia" :key="index">
        <a :href="item.url" class=""><i :class="item.icon"></i></a>
      </li>
    </ul>
  </section>

  <!--Some Services-->
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div id="services-slider" class="owl-carousel">
          <div class="item">
            <div class="service-box">
              <i
                class="bi bi-lightning-charge-fill"
                style="font-size: 55px !important;"
              ></i>
              <h4 class="bottom10 text-nowrap text-bold">
                <a href="/layanan-permohonan-daya"
                  ><strong
                    >Dukungan <br />
                    Daya Sementara</strong
                  ></a
                >
              </h4>
              <p class="text-color-secondary">
                Permohonan dukungan daya sementara untuk kegiatan
              </p>
              <a
                href="/layanan-permohonan-daya"
                class="btn bg-custom-secondary mt-5 text-white"
              >
                Telusuri Layanan
              </a>
            </div>
          </div>
          <div class="item">
            <div class="service-box">
              <i
                class="bi bi-file-earmark-text"
                style="font-size: 55px !important"
              ></i>
              <h4 class="bottom10 text-nowrap text-bold">
                <a href="/layanan-iuptl"
                  ><strong
                    >Pelaporan <br />
                    IUPTLS / IUPTLU / IUJPTL</strong
                  ></a
                >
              </h4>
              <p>
                Pelaporan Izin Usaha Penyedia Tenaga Listrik Sementara / Izin
                Usaha Penyedia Tenaga Listrik Umum / Izin Usaha Jasa Penyedia
                Tenaga Listrik
              </p>
              <a
                href="/layanan-iuptl"
                class="btn bg-custom-secondary text-white"
              >
                Telusuri Layanan
              </a>
            </div>
          </div>
          <div class="item">
            <div class="service-box">
              <i
                class="bi bi-envelope-paper"
                style="font-size: 55px !important"
              ></i>
              <!-- <h4 class="bottom10"><a href="javascript:void(0)">Digital Access</a></h4> -->
              <h4 class="bottom10 text-nowrap text-bold">
                <a href="/layanan-suket"
                  ><strong
                    >Pelaporan <br />
                    Surat Keterangan</strong
                  ></a
                >
              </h4>
              <p>
                Pelaporan Usaha Penyediaan Tenaga Listrik Untuk Kepentingan
                Sendiri
              </p>
              <a
                href="/layanan-suket"
                class="btn bg-custom-secondary mt-5 text-white"
              >
                Telusuri Layanan
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Some Services ends-->
  <!--Some Feature -->
  <section id="about" class="single-feature padding mt-n5">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <!-- <div id="about-slider" class="owl-carousel">
            <div class="item"> -->
          <div class="row d-flex align-items-center">
            <div
              class="col-lg-6 text-sm-left text-center wow fadeInLeft"
              data-wow-delay="300ms"
            >
              <div class="heading-title mb-4">
                <h2 class="darkcolor font-normal bottom30">
                  <span class="defaultcolor">{{ aboutUsData.title_1 }}</span>
                  <br />
                  {{ aboutUsData.title_2 }}
                </h2>
              </div>
              <p class="bottom35">
                {{ aboutUsData.content }}
              </p>
              <!-- <a
                href="javascript:void(0)"
                class="button gradient-btn bg-custom mb-sm-0 mb-4"
                >Baca Selengkapnya</a
              > -->
            </div>
            <div class="col-lg-6 wow fadeInRight" data-wow-delay="300ms">
              <div class="image">
                <img
                  alt="SEO"
                  :src="getFilePath('about-us', aboutUsData.image)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div>
    </div> -->
  </section>
  <!--Some Feature ends-->

  <!-- Counters -->
  <section id="bg-counters" class="padding bg-counters">
    <div class="container">
      <div class="align-items-center text-center mb-2">
        <h2 class="text-white">Statistik</h2>
      </div>
      <div class="row align-items-center text-center mt-5">
        <div class="col-lg-4 col-md-4 col-sm-4 bottom10">
          <i class="fas fa-user text-white" style="font-size: 60px"></i>
          <div class="counters whitecolor top10 bottom10">
            <h3 class="font-light" v-show="!isLoading">
              <b>{{ statistikData.total_user }}</b> Pengguna
            </h3>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 bottom10">
          <i class="fas fa-envelope text-white" style="font-size: 60px"></i>
          <div class="whitecolor fs-1 top10 bottom10">
            <h3 class="font-light" v-show="!isLoading"> <b>{{
              statistikData.suket
            }}</b> Laporan Terkirim</h3>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 bottom10">
          <i class="fas fa-charging-station text-white" style="font-size: 60px"></i>
          <div class="whitecolor fs-1 top10 bottom10">
            <h3 class="font-light" v-show="!isLoading"> <b>{{
              statistikData.spklu
            }}</b> Total SPKLU</h3>
          </div>
        </div>
      </div>
      
      <!-- <div class="row">
        <div class="col-lg-1 col-md-1"></div>
        <div class="col-lg-2 col-md-2">
              <div class="text-center w-100 p-0">
                  <div class="contact-box">
                      <span class="icon-contact"><i class="bi bi-lightning-charge-fill" style="font-size: 50px;"></i></span>
                      <p class="bottom15" v-show="!isLoading" style="font-size: 20px;">DAYA <span class="d-block"><h3><b>{{ statistikData.daya }}</b></h3></span></p>
                  </div>
              </div>
        </div>
        <div class="col-lg-2 col-md-2">
              <div class="text-center w-100 p-0">
                  <div class="contact-box">
                      <span class="icon-contact"><i class="bi bi-file-earmark-text-fill" style="font-size: 50px;"></i></span>
                      <p class="bottom15" v-show="!isLoading" style="font-size: 20px;">IUPTLS <span class="d-block"><h3><b>{{ statistikData.iuptls }}</b></h3></span></p>
                  </div>
              </div>
        </div>
        <div class="col-lg-2 col-md-2">
              <div class="text-center w-100 p-0">
                  <div class="contact-box">
                      <span class="icon-contact"><i class="bi bi-file-earmark-text-fill" style="font-size: 50px;"></i></span>
                      <p class="bottom15" v-show="!isLoading" style="font-size: 20px;">IUPTLU <span class="d-block"><h3><b>{{ statistikData.iuptlu }}</b></h3></span></p>
                  </div>
              </div>
        </div>
        <div class="col-lg-2 col-md-2">
              <div class="text-center w-100 p-0">
                  <div class="contact-box">
                      <span class="icon-contact"><i class="bi bi-file-earmark-text-fill" style="font-size: 50px;"></i></span>
                      <p class="bottom15" v-show="!isLoading" style="font-size: 20px;">IUJPTL <span class="d-block"><h3><b>{{ statistikData.iujptl }}</b></h3></span></p>
                  </div>
              </div>
        </div>
        <div class="col-lg-2 col-md-2">
              <div class="text-center w-100 p-0">
                  <div class="contact-box">
                      <span class="icon-contact"><i class="bi bi-envelope-paper-fill" style="font-size: 50px;"></i></span>
                      <p class="bottom15" v-show="!isLoading" style="font-size: 20px;">SUKET <span class="d-block"><h3><b>{{ statistikData.suket }}</b></h3></span></p>
                  </div>
              </div>
        </div>
        <div class="col-lg-1 col-md-1"></div>
      </div> -->

      <div class="charts-container">

        <!-- Chart utama -->
        <div class="chart-box full-width">
          <highcharts :options="chartSumSuket" />
        </div>

        <!-- Chart bawah -->
        <div class="chart-box">
          <highcharts :options="chartPltd" />
        </div>

        <div class="chart-box">
          <highcharts :options="chartPlts" />
        </div>

      </div>

    </div>
  </section>
  <!-- Counters ends-->

  <!-- Our Blogs -->
  <section
    id=""
    class="bglight padding_top padding_bottom_half"
    style="
      background-image: url(/fe/asset/img/merg1.png);
      background-size: 100% 100%;
    "
  >
    <div class="container">
      <div class="row">
        <div
          class="col-md-12 text-center wow fadeIn top15"
          data-wow-delay="300ms"
          style="
            visibility: visible;
            animation-delay: 300ms;
            animation-name: fadeIn;
          "
        >
          <h2 class="text-white font-normal bottom30">
            Berita <span class="defaultcolor">Terkini</span>
          </h2>
          <div class="col-md-6 offset-md-3 bottom40 text-white">
            <p>
              <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A
              dolores quam reiciendis voluptatum. -->
            </p>
          </div>
        </div>
      </div>
      <div class="cbp cbp-ready">
        <div class="row">
          <div v-for="item in listBerita" :key="item" class="col-md-4">
            <div class="mt-3 mb-3">
              <div class="news_item shadow text-center text-md-left">
                <a :href="`/news-detail?prefix=${item.slug}`" class="image">
                  <img
                    :src="getFilePath('news', item.thumbnail)"
                    alt="Latest News"
                    class="img-responsive"
                    style="max-height: 180px !important; object-fit: cover"
                  />
                </a>
                <div
                  class="news_desc text-center"
                  style="max-height: 300px; min-height: 300px"
                >
                  <h5 class="text-capitalize font-normal defaultcolor">
                    <a :href="`/news-detail?prefix=${item.slug}`">{{
                      item.title
                    }}</a>
                  </h5>
                  <ul class="meta-tags top10 bottom20">
                    <li>
                      <a :href="`/news-detail?prefix=${item.slug}`"
                        ><i class="fas fa-calendar-alt"></i
                        >{{ fomatDateTimeIndo(item.createdAt) }}</a
                      >
                    </li>
                  </ul>
                  <p
                    class="bottom35 text-white"
                    v-html="limitString(item.content, 100)"
                  ></p>
                  <a
                    :href="`/news-detail?prefix=${item.slug}`"
                    class="button btn-secondary bg-custom"
                    >Selengkapnya</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <!--Pagination-->
            <ul
              class="pagination top55 justify-content-center mb-4 mb-md-0 mb-sm-3"
            >
              <!-- <li class="page-item">
                <a class="page-link disabled" href="#."
                  ><i class="fa fa-angle-left"></i
                ></a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="#.">1</a>
              </li>
              <li class="page-item"><a class="page-link" href="#.">2</a></li>
              <li class="page-item"><a class="page-link" href="#.">3</a></li>
              <li class="page-item">
                <a class="page-link" href="#."
                  ><i class="fa fa-angle-right"></i
                ></a>
              </li> -->

              <!-- <li class="page-item">
                <a
                  class="page-link"
                  href="javascript:void(0)"
                  @click="handlePrev"
                  ><i class="fa fa-angle-left"></i
                ></a>
              </li> -->

              <li
                class="page-item"
                :class="beritaMeta.page == index + 1 ? 'active' : ''"
                v-for="(item, index) in Math.ceil(
                  beritaMeta.total / beritaMeta.limit
                )"
                :key="index"
              >
                <a
                  class="page-link"
                  href="javascript:void(0)"
                  @click="handlePage(index + 1)"
                  >{{ index + 1 }}</a
                >
              </li>

              <!-- <li class="page-item">
                <a
                  class="page-link"
                  href="javascript:void(0)"
                  @click="handleNext"
                  ><i class="fa fa-angle-right"></i
                ></a>

              </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    class="bglight padding_top padding_bottom_half"
    style="
      background-image: url(/fe/asset/img/merg2.png);
      background-size: 100% 100%;
    "
  >
    <div class="container">
      <br />
      <br />
      <br />
      <div class="row">
        <div
          class="col-md-12 text-center wow fadeIn top55"
          data-wow-delay="300ms"
          style="
            visibility: visible;
            animation-delay: 300ms;
            animation-name: fadeIn;
          "
        >
          <h2 class="text-white font-normal bottom30">
            Galeri <span class="defaultcolor">Kegiatan</span>
          </h2>
          <div class="col-md-6 offset-md-3 bottom40 text-white">
            <p>
              <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A
              dolores quam reiciendis voluptatum. -->
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div
            id="mosaic-filter"
            class="cbp-l-filters bottom30 wow fadeIn text-center"
            data-wow-delay="350ms"
          >
            <div
              data-filter="*"
              class="cbp-filter-item text-white"
              :class="
                galeryParams.parent_id == '' ? 'cbp-filter-item-active' : ''
              "
              @click="handleFilterGalery('')"
            >
              <span>All</span>
            </div>

            <div
              v-for="item in listAlbums"
              :key="item"
              @click="handleFilterGalery(item.slug)"
              :data-filter="`.${item.slug}`"
              class="cbp-filter-item"
              :class="
                galeryParams.parent_id == item.slug
                  ? 'cbp-filter-item-active'
                  : ''
              "
            >
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div id="" class="cbp cbp-ready">
            <div class="text-center demo-image__preview">
              <template v-for="(item, key) in listGallery" :key="key">
                <el-image
                  style="max-width: 200px; max-height: 200px; object-fit: cover"
                  :src="getFilePath('gallery', item.image)"
                  :zoom-rate="1.2"
                  :max-scale="7"
                  :min-scale="0.2"
                  :preview-src-list="srcList"
                  :initial-index="4"
                  fit="cover"
                  @show="handleShow"
                  @close="handleClose"
                />
                <template v-for="child in item.children" :key="child">
                  <el-image
                    style="
                      max-width: 200px;
                      max-height: 200px;
                      object-fit: cover;
                    "
                    :src="getFilePath('gallery', child.image)"
                    :zoom-rate="1.2"
                    :max-scale="7"
                    :min-scale="0.2"
                    :preview-src-list="srcList"
                    :initial-index="4"
                    fit="contain"
                    @show="handleShow"
                    @close="handleClose"
                  />
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--Our Blogs Ends-->
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, onMounted, reactive, ref } from "vue";
import { useCmsStores } from "@/store/cms";
import { getFilePath } from "@/core/helpers/assets";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
import { fomatDateTimeIndo } from "@/core/helpers/date";
import Highcharts from 'highcharts'

export default defineComponent({
  name: "HomeView",
  components: {
    HelloWorld,
  },
  setup() {
    const cmsStore = useCmsStores();
    const loadingGallery = ref(false);
    const isLoading = ref(false);

    onMounted(async () => {
      isLoading.value = true;
      await getSlider();
      await getSocialMedia();
      await getAboutUs();
      await getBerita();
      await getAlbums();
      await getStatistik();
      await fetchSumSuket();
      await fetchChartPltd();
      await fetchChartPlts();

      loadingGallery.value = true;
      await getGalery();
      loadingGallery.value = false;
      isLoading.value = false;
    });

    const listSocialMedia = ref([]);
    const getSocialMedia = async () => {
      const params = {
        status: 1,
      };
      await cmsStore
        .getSocialMedia(params)
        .then((res) => {
          listSocialMedia.value = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const aboutUsData = ref([]);
    const getAboutUs = async () => {
      await cmsStore
        .getAboutUs()
        .then((res) => {
          aboutUsData.value = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const listSlider = ref([]);
    const sliderData = [];
    const getSlider = async () => {
      await cmsStore.getHomeSlider().then((res) => {
        listSlider.value = res.data.data.data;
      });

      listSlider.value.forEach((item) => {
        sliderData.push({
          image: getFilePath("slider", item.image),
          title: item.title,
          description: item.content,
        });
      });

      // console.log(sliderData);

      const sliderList = document.querySelector(".slider .list");
      const pagination = document.querySelector(".tp-bullets");

      sliderData.forEach((item, index) => {
        const sliderItem = document.createElement("div");
        sliderItem.classList.add("item");
        if (index === 0) {
          sliderItem.classList.add("active");
        }

        const img = document.createElement("img");
        img.src = item.image;
        img.alt = item.title;

        const content = document.createElement("div");
        content.classList.add("content");

        const h2 = document.createElement("h2");
        h2.textContent = item.title;

        const p = document.createElement("p");
        p.textContent = item.description;

        content.appendChild(h2);
        content.appendChild(p);

        sliderItem.appendChild(img);
        sliderItem.appendChild(content);

        sliderList.appendChild(sliderItem);

        // Create pagination bullets
        const bullet = document.createElement("div");
        bullet.classList.add("tp-bullet");
        if (index === 0) {
          bullet.classList.add("selected");
        } else {
          bullet.style.top = `${index * 10}px`;
          bullet.style.left = "0px";
        }

        const bulletNumber = document.createElement("div");
        bulletNumber.classList.add("tp-bullet-number");

        if (index < 9) {
          bulletNumber.innerHTML = `<span class="tp-count">0${
            index + 1
          }</span><span class="tp-bullet-line"></span>`;
        } else {
          bulletNumber.innerHTML = `<span class="tp-count">${
            index + 1
          }</span><span class="tp-bullet-line"></span>`;
        }

        bullet.appendChild(bulletNumber);
        pagination.appendChild(bullet);
      });

      // Slider functionality
      const items = document.querySelectorAll(".slider .list .item");
      const paginationItems = document.querySelectorAll(
        ".tp-bullets .tp-bullet"
      );

      let currentIndex = 0;
      let interval = setInterval(() => {
        currentIndex++;
        if (currentIndex > items.length - 1) {
          currentIndex = 0;
        }
        changeSlide(currentIndex);
      }, 5000);

      function changeSlide(index) {
        items.forEach((item, i) => {
          if (i === index) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
        });

        paginationItems.forEach((item, i) => {
          if (i === index) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
      }

      paginationItems.forEach((item, i) => {
        item.addEventListener("click", () => {
          clearInterval(interval);
          changeSlide(i);
          currentIndex = i;
          interval = setInterval(() => {
            currentIndex++;
            if (currentIndex > items.length - 1) {
              currentIndex = 0;
            }
            changeSlide(currentIndex);
          }, 5000);
        });
      });
    };

    const listBerita = ref([]);
    const beritaMeta = reactive({
      total: 0,
      page: 1,
      limit: 3,
      offset: 0,
    });
    const queryBerita = reactive({
      page: 1,
      limit: 3,
      offset: 0,
      orderBy: "createdAt",
      sort: "desc",
      status: "published",
    });
    const getBerita = async () => {
      await cmsStore.getNews(queryBerita).then((res) => {
        listBerita.value = res.data.data.data;
        beritaMeta.total = res.data.data.total_data;
        beritaMeta.page = res.data.data.page;
        beritaMeta.limit = res.data.data.limit;
        beritaMeta.offset = res.data.data.offset;
      });
    };

    const limitString = (string, value) => {
      if (string.length <= value) {
        return string;
      }

      return string.substring(0, value) + "...";
    };

    const handlePrev = async () => {
      if (beritaMeta.page > 1) {
        queryBerita.page = beritaMeta.page - 1;
        queryBerita.offset = beritaMeta.offset - beritaMeta.limit;
        await getBerita();
      }
    };

    const handleNext = async () => {
      if (beritaMeta.page < Math.ceil(beritaMeta.total / beritaMeta.limit)) {
        beritaMeta.page = beritaMeta.page + 1;
        queryBerita.page = beritaMeta.page + 1;
        queryBerita.offset = beritaMeta.offset + beritaMeta.limit;
        await getBerita();
      }
    };

    const handlePage = async (page) => {
      queryBerita.page = page;
      queryBerita.offset = (page - 1) * beritaMeta.limit;

      await getBerita();

      beritaMeta.page = page;
    };

    const listAlbums = ref([]);
    const getAlbums = async () => {
      await cmsStore.getGallery({}).then((res) => {
        listAlbums.value = res.data.data.data;
      });
    };

    const listGallery = ref([]);
    const srcList: any = ref([]);
    const galeryParams = reactive({
      parent_id: "",
    });
    const getGalery = async () => {
      await cmsStore.getGallery(galeryParams).then((res) => {
        srcList.value = [];
        listGallery.value = res.data.data.data;

        listGallery.value.forEach((item) => {
          srcList.value.push(getFilePath("gallery", item.image));
          item.children.forEach((child) => {
            srcList.value.push(getFilePath("gallery", child.image));
          });
        });
      });
    };

    const handleShow = (index) => {
      document.querySelector("nav").style.display = "none";
    };

    const handleClose = () => {
      document.querySelector("nav").style.display = "block";
    };

    const handleFilterGalery = async (slug) => {
      loadingGallery.value = true;
      galeryParams.parent_id = slug;
      await getGalery();
      loadingGallery.value = false;
    };

    const statistikData = reactive({
      total_user: 0,
      total_laporan: 0,
      iuptls: 0,
      iuptlu: 0,
      iujptl: 0,
      daya: 0,
      suket: 0,
      spklu: 0,
    });

    const getStatistik = async () => {
      await cmsStore.getStatistik().then((res) => {
        statistikData.total_user = res.data.data.jumlahPengguna;
        statistikData.total_laporan = res.data.data.jumlahLaporan;
        statistikData.iuptls = res.data.data.jumlahIuptls;
        statistikData.iuptlu = res.data.data.jumlahIuptlu;
        statistikData.iujptl = res.data.data.jumlahIujptl;
        statistikData.daya = res.data.data.jumlahPermohonanDaya;
        statistikData.suket = res.data.data.jumlahSuratKeterangan;
        statistikData.spklu = res.data.data.jumlahSpklu
      });

      // console.log(statistikData);
    };

    const chartSumSuket = ref({
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
      },
      title: {
        text: 'SUKET',
        style: {
          color: '#ffffff',
          fontSize: '18px',
          fontWeight: '600'
        }
      },
      plotOptions: {
        pie: {
          innerSize: '60%',
          borderWidth: 0,
          dataLabels: { enabled: false },
          showInLegend: true
        }
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          color: '#fff'
        }
      },
      series: []
    })

    const fetchSumSuket = async () => {
      await cmsStore.getSumSuket().then((res) => {
        const data = res.data.data;

        chartSumSuket.value.series = [
          {
            name: 'Jumlah',
            colorByPoint: true,
            data: [
              {
                name: 'PLTD',
                y: Number(data.jumlah_pltd),
                color: '#facc15'
              },
              {
                name: 'PLTS',
                y: Number(data.jumlah_plts),
                color: '#f59e0b'
              }
            ]
          }
        ]
      });
    };

    const chartPltd = ref({
      chart: {
        type: 'bar',
        backgroundColor: 'transparent',
      },

      colors: ['#facc15'], // warna utama (kuning)

      title: {
        text: 'Daya Pembangkit PLTD',
        style: {
          color: '#ffffff',
          fontSize: '18px',
          fontWeight: '600'
        }
      },

      xAxis: {
        categories: [],
        labels: {
          style: {
            color: '#ffffff'
          }
        },
        lineColor: 'rgba(255,255,255,0.3)'
      },

      yAxis: {
        title: {
          text: 'Jumlah Kapasitas',
          style: {
            color: '#ffffff'
          },
        },
        labels: {
          style: {
            color: '#ffffff'
          }
        },
        gridLineColor: 'rgba(255,255,255,0.1)'
      },

      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.8)',
        style: {
          color: '#fff'
        },
        formatter: function () {
          return `
            <b>${this.point.jenis}</b><br/>
            Jumlah Permohonan: ${this.y}<br/>
            Total Kapasitas: ${this.point.kapasitas} ${this.point.satuan}
          `
        }
      },

      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          color: '#ffffff'
        }
      },

      plotOptions: {
        bar: {
          borderRadius: 6,
          dataLabels: {
            enabled: true,
            style: {
              color: '#ffffff',
              textOutline: 'none'
            }
          }
        },
        series: {
          colorByPoint: true // 🔥 beda warna tiap bar
        }
      },

      series: []
    })

    const fetchChartPltd = async () => {
      await cmsStore.getChartPltd().then((res) => {
        const raw = res.data.data

        const categories = []
        const data = []

        raw.forEach(item => {
          const label = `${item.jenis} (${item.status_kapasitas})`

          categories.push(label)

          data.push({
            y: Number(item.jumlah_permohonan),
            jenis: item.jenis,
            kapasitas: parseFloat(item.total_kapasitas),
            satuan: item.status_kapasitas,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
              stops: [
                [0, '#facc15'], // kuning terang
              ]
            }
          })
        })

        chartPltd.value.xAxis.categories = categories

        chartPltd.value.series = [
          {
            name: 'Jumlah Permohonan',
            data: data
          }
        ]
      });
    }

    const chartPlts = ref({
      chart: {
        type: 'bar',
        backgroundColor: 'transparent'
      },

      title: {
        text: 'Daya Pembangkit PLTS',
        style: {
          color: '#ffffff',
          fontSize: '18px',
          fontWeight: '600'
        }
      },

      xAxis: {
        categories: [],
        labels: {
          style: {
            color: '#ffffff'
          }
        },
        lineColor: 'rgba(255,255,255,0.3)'
      },

      yAxis: {
        title: {
          text: 'Jumlah Kapasitas',
          style: {
            color: '#ffffff'
          }
        },
        labels: {
          style: {
            color: '#ffffff'
          }
        },
        gridLineColor: 'rgba(255,255,255,0.1)'
      },

      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          color: '#ffffff'
        }
      },

      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.8)',
        style: {
          color: '#fff'
        },
        formatter: function () {
          return `
            <b>${this.point.name}</b><br/>
            Jumlah Permohonan: ${this.y}<br/>
            Total Unit: ${this.point.unit}<br/>
            Total Kapasitas: ${this.point.kapasitas} ${this.point.satuan}
          `
        }
      },

      plotOptions: {
        bar: {
          borderRadius: 6,
          dataLabels: {
            enabled: true,
            style: {
              color: '#ffffff',
              textOutline: 'none'
            }
          }
        },
        series: {
          colorByPoint: true,
          showInLegend: true // 🔥 legend per jenis
        }
      },

      series: []
    })

    const fetchChartPlts = async () => {
      const res = await cmsStore.getChartPlts()
      const raw = res.data.data

      const categories = []
      const data = []

      raw.forEach(item => {
        const label = `${item.jenis} (${item.status_kapasitas})`

        categories.push(label)

        data.push({
          name: label, // untuk legend
          y: Number(item.jumlah_permohonan),
          jenis: item.jenis,
          unit: Number(item.total_unit),
          min: Math.round(Number(item.min_kapasitas)),
          max: Math.round(Number(item.max_kapasitas)),
          kapasitas: Math.round(Number(item.total_kapasitas)),
          satuan: item.status_kapasitas,

          // warna gradient sama seperti PLTD & donut
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, '#f59e0b'], // kuning
            ]
          }
        })
      })

      chartPlts.value.xAxis.categories = categories

      chartPlts.value.series = [
        {
          name: 'Jumlah Permohonan',
          data: data
        }
      ]
    }

    // setting highchart
    Highcharts.setOptions({
      lang: {
        locale: 'id-ID'
      }
    })

    return {
      cmsStore,
      listSocialMedia,
      aboutUsData,
      getAboutUs,
      getFilePath,
      listSlider,
      listBerita,
      fomatDateTimeIndo,
      limitString,
      beritaMeta,
      handlePrev,
      handleNext,
      handlePage,
      listGallery,
      loadingGallery,
      srcList,
      handleShow,
      handleClose,
      galeryParams,
      handleFilterGalery,
      listAlbums,
      statistikData,
      isLoading,
      chartSumSuket,
      chartPltd,
      chartPlts
    };
  },
});
</script>


<style scoped>
.demo-image__error .image-slot {
  font-size: 30px;
}
.demo-image__error .image-slot .el-icon {
  font-size: 30px;
}
.demo-image__error .el-image {
  width: 100%;
  height: 300px;
}
.widget {
  background: white;
}

.widget:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.contact-box {
  color: white;
}

/* Charts Container */
  .charts-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    margin-top: 3rem;
    background: rgba(0, 0, 0, 0.2);
    padding: 2rem;
    border-radius: 12px;
  }

  /* chart utama full width */
  .full-width {
    grid-column: 1 / -1;
  }

  /* styling card */
  .chart-box {
    background: rgba(255, 255, 255, 0.1);
    padding: 1.5rem;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);

    width: 100%;
    height: 420px;
  }

  .chart-title {
      font-size: 1rem;
      margin-bottom: 1rem;
      color: white;
      font-weight: 600;
  }

  .chart-canvas {
      max-height: 250px;
  }

  .chart-box > div {
    width: 100% !important;
    height: 100% !important;
  }

/* .icon-contact {
  color: #FD9329;
} */
</style>